import { configureStore } from "@reduxjs/toolkit";

import eventReducer from "./events/eventSlice";
import galleryReducer from "./galleries/gallerySlice";
import contactReducer from "./contact/contactSlice";
import adminReducer from "./admin/adminSlice";
import projetReducer from "./projects/projectSlice";

export const store = configureStore({
  reducer: {
    events: eventReducer,
    galleries: galleryReducer,
    contact: contactReducer,
    admin: adminReducer,
    projets: projetReducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
